const snakewave=()=>{
    return(
        <>
            <div className="container-fluid p-0">
                <div className="wave-slider-wrapper">
                    <div className="wave-slider pb-5">
                        {"WARNING: may cause eat repeat eat eat repeat eat eat repeat eat eat repeat eat eat repeat eat urge • WARNING: may cause eat repeat eat eat repeat eat eat repeat eat eat repeat eat eat repeat eat urge •  "
                        .split("")
                        .map((char, i) => (
                            <span key={i} style={{ animationDelay: `${i * 0.05}s` }}>
                            {char}
                            </span>
                        ))}
                </div>
                </div>
            </div>
        </>
    )   
}
export default snakewave